/**
 * @file This is the util service module
 * @copyright Andreas Horvath 2016-2024
 * @version 0.2.0
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor() {}

  isMobile(): boolean {
    if (window.matchMedia('only screen and (max-width: 760px)').matches)
      return true;

    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  isTouchDevice(): boolean {
    if (!!(window as any).isTouchDevice) return true;
    if (window.matchMedia('(pointer: coarse)').matches) {
      (window as any).isTouchDevice = true;
      return true;
    }
  }

  /**
   * Checks if the current date is within the Christmas time period
   * @returns true if current date is between mid-November (15th) and January 6th
   */
  isChristmasTime(): boolean {
    const now = new Date();
    const currentYear = now.getFullYear();
    const month = now.getMonth(); // 0-11
    const day = now.getDate();

    // Mid November (Nov 15) to end of year
    if (month === 10 && day >= 15) {
      // November (month 10)
      return true;
    }
    if (month === 11) {
      // December (month 11)
      return true;
    }
    // January 1 to January 6
    if (month === 0 && day <= 6) {
      // January (month 0)
      return true;
    }

    return false;
  }
}
